export default "__VITE_ASSET__de97ef76__"